module.exports = __webpack_public_path__ + "media/assets/images/flags/bo-52519574fa5cd095417e5a7032ffefbc.svg";